export interface GrassTooth {
  leftX: number;
  apexX: number;
  rightX: number;
}

export function createGrassTeeth(leftX: number, width: number, preferredToothWidth: number): GrassTooth[] {
  if (![leftX, width, preferredToothWidth].every(Number.isFinite) || width <= 0 || preferredToothWidth <= 0) return [];
  const toothCount = Math.max(1, Math.round(width / preferredToothWidth));
  const toothWidth = width / toothCount;

  return Array.from({ length: toothCount }, (_, index) => {
    const toothLeftX = leftX + toothWidth * index;
    const rightX = index === toothCount - 1 ? leftX + width : toothLeftX + toothWidth;
    return {
      leftX: toothLeftX,
      apexX: (toothLeftX + rightX) / 2,
      rightX,
    };
  });
}
